var productCards = document.querySelectorAll(".product-card-container")

productCards.forEach( product => {
    var mainImage = product.querySelector(".image-wrapper img");
    var mainImageSrc = mainImage.src

    var variants = product.querySelectorAll(".variant-selector .variant-item");

    variants.forEach( variant => {
        variant.addEventListener("mouseover", () => {
            mainImage.src = variant.dataset.src;
        });

        variant.addEventListener("mouseleave", () => {
            mainImage.src = mainImageSrc;
        });
    });
});